;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();type WorkflowListKeyParams = {
	viewVisualizationGroupId?: string;
	workspaceId: string;
};

export const workflowQueryKeys = {
	all: ["workflows"] as const,
	list: ({ viewVisualizationGroupId, workspaceId }: WorkflowListKeyParams) =>
		[
			...workflowQueryKeys.workspacePrefix(workspaceId),
			viewVisualizationGroupId,
		] as const,
	workspacePrefix: (workspaceId: string) =>
		[...workflowQueryKeys.all, workspaceId] as const,
};

export const workflowMutationKeys = {
	create: ({ viewVisualizationGroupId, workspaceId }: WorkflowListKeyParams) =>
		[
			...workflowQueryKeys.list({
				viewVisualizationGroupId,
				workspaceId,
			}),
			"create",
		] as const,
	delete: ({ viewVisualizationGroupId, workspaceId }: WorkflowListKeyParams) =>
		[
			...workflowQueryKeys.list({
				viewVisualizationGroupId,
				workspaceId,
			}),
			"delete",
		] as const,
};
